// Third-party Libraries
import styled from 'styled-components';

// Material UI
import { Badge } from '@mui/material';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import CommentOutlined from '@mui/icons-material/CommentOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import PlaylistAddCheckOutlined from '@mui/icons-material/PlaylistAddCheckOutlined';
import RateReviewOutlined from '@mui/icons-material/RateReviewOutlined';
import ReviewsOutlined from '@mui/icons-material/ReviewsOutlined';
import WorkHistoryOutlined from '@mui/icons-material/WorkHistoryOutlined';

// Constants
import { mediaQueries } from '../../constants/breakpoints';

export const Container = styled.div`
  position: fixed;
  top: 61px;
  right: 0;
  width: 51px;
  height: calc(100% - 172px);
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: start;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);
  @media ${mediaQueries.desktop} {
    position: relative;
    top: 0;
    height: 100%;
    min-width: 51px;
    margin-left: auto;
  }
  @media ${mediaQueries.mobile} {
    box-shadow: 0px 0px 0px 0px;
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
`;
export const NavContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  min-width: 51px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ecf3f9;
  z-index: 5;
  @media ${mediaQueries.mobile} {
    top: 1px;
    min-width: 49px;
  }
`;
export const AddNewIcon = styled(PersonOutlineOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;
export const OrderIcon = styled(AssignmentOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;
export const OrderWithBadgikIcon = styled(AssignmentOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 0;
  cursor: pointer;
`;
export const ProductIcon = styled(Inventory2Outlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;
export const TicketIcon = styled(PlaylistAddCheckOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;

export const CommentIcon = styled(CommentOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;

export const CommentWithBadgikIcon = styled(CommentOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 0;
  cursor: pointer;
`;
export const Badgik = styled(Badge)`
  margin-top: 40px;
`;

export const WorkHistoryIcon = styled(WorkHistoryOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;

export const FeedbackIcon = styled(RateReviewOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;

export const ReviewIcon = styled(ReviewsOutlined)`
  width: 20px;
  height: 20px;
  margin-top: 40px;
  cursor: pointer;
`;
